import React from 'react';
import './Navbar.css';

const Navbar = React.memo(() => {
  return (
    <header className="navbar" role="banner">
      <nav className="navbar-container" aria-label="Navegación principal">
        <div className="navbar-logo">
          <a
            href="https://www.monkeyfitpass.com/"
            aria-label="Ir a MonkeyFit Pass"
            rel="noopener noreferrer"
          >
            <img
              src="/images/logo.png"
              alt="MonkeyFit Logo"
              className="logo"
              width="180"
              height="auto"
            />
          </a>
        </div>

        <div className="navbar-cta">
          <a
            href="https://www.monkeyfitpass.com/"
            className="cta-button"
            aria-label="Ir a la plataforma MonkeyFit"
            rel="noopener noreferrer"
          >
            Ir a la plataforma
          </a>
        </div>
      </nav>
    </header>
  );
});

Navbar.displayName = 'Navbar';

export default Navbar;
